import { useEffect, useState } from 'react';
import { t } from 'autobiz-translate';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { recordActions } from '../../config/configuration/react';

export const useGuaranteeHistory = (recordId) => {
  const dispatch = useDispatch();
  const [historyResponse, setHistoryResponse] = useState([]);
  const guaranteedPrice = useSelector((state) => state.reduxRecords.data[recordId]?.guaranteedPrice || []);

  const getHistoryNrm = async (nrmRecordId) => {
    const res = await dispatch(recordActions.getHistoryNrm(nrmRecordId));
    setHistoryResponse([...res]);
  };

  useEffect(() => {
    getHistoryNrm(guaranteedPrice?.nrmRecordId);
  }, []);

  const formatMessage = (message) => {
    if (message !== null) {
      const stringInTable = message.split('||');
      return stringInTable
        .map((e) => {
          const label = e.split(':')[0].replace(/§§|\s/g, '');
          const value = e.split(':')[1].replace(/§§/g, '');
          if (['guaranteeValidUntil', 'expectedEntryStockDate'].includes(label))
            return { [t(label)]: moment(value).format('DD/MM/YYYY') };
          if (['autobizComment', 'finalisationCanceledComment'].includes(label)) return { [t(label)]: value };
          return { [t(label)]: t(value.replace(/\s/g, '')) };
        })
        .filter((e) => !Object.values(e).includes('null'));
    }
    return null;
  };

  return {
    historyResponse,
    formatMessage,
  };
};
